import { render, staticRenderFns } from "./Pv.vue?vue&type=template&id=4cf43f7e&scoped=true&"
import script from "./Pv.vue?vue&type=script&lang=js&"
export * from "./Pv.vue?vue&type=script&lang=js&"
import style0 from "./Pv.vue?vue&type=style&index=0&id=4cf43f7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf43f7e",
  null
  
)

export default component.exports